<template>
  <div class="overdue-float-view">
    <img src="./images/icon_tanhao01@2x.png">
    <template v-if="isOverdue==='N'">
      <div class="content-slot" @click="repayAction">
        <div class="top">今日到期应还 <span class="bold">{{ amount }}</span>元</div>
        <div class="bottom">避免逾期对您的信用造成影响，点击<span class="text-primary">去还款></span></div>
      </div>
    </template>
    <template v-else>
      <div class="content-slot" @click="checkAccount">
        <div class="top"><span class="text-primary"> 你已逾期</span>（逾期或将产生罚息），请立即还款</div>
        <div class="bottom">今天系统或将进行扣款，<span class="text-primary">查看扣款账户></span></div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    amount: {
      type: Number,
      default: 0
    },
    isOverdue: {
      type: String,
      default: 'N'
    }
  },
  methods: {
    repayAction () {
      this.$emit('onRepay')
    },
    checkAccount () {
      this.$emit('onCheckAccount')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.overdue-float-view {
  width: 10rem;
  height: 120px;
  background: #FFECEA;
  padding: 20px 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  img {
    width: 32px;
    height: 32px;
    margin-top: 3px;
  }
  .content-slot {
    margin-left: 8px;
    font-size: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }
  .text-primary {
    color: #FF4633;
  }
  .bold {
    font-weight: 600;
  }
}
</style>